







import { Member } from "@/api/models";
import MemberView from "@/components/widgets/MemberView.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    MemberView
  }
})
export default class MemberSet extends Vue {
  @Prop({ default: () => [] }) members: Array<Member>;
}
